import { render, staticRenderFns } from "./ParticipacaoResultado.vue?vue&type=template&id=8f3c2aa8"
import script from "./ParticipacaoResultado.vue?vue&type=script&lang=js"
export * from "./ParticipacaoResultado.vue?vue&type=script&lang=js"
import style0 from "./ParticipacaoResultado.vue?vue&type=style&index=0&id=8f3c2aa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports